@use "/src/styles/functions.scss";

$animation-time: functions.speed(fast);

.input-icon {
  border: none;
  transition: all $animation-time ease-in-out;
  cursor: pointer;
  outline: none;
  flex: 0 0 auto;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: functions.getThemeColor("icon-soft-400");
  background-color: transparent;
  &:hover,
  &:focus {
    color: functions.getThemeColor("icon-sub-600");
  }
  &:focus-visible {
    outline: 1px functions.getThemeColor("text-strong-900") dashed;
  }
}
